import { render, staticRenderFns } from "./RichWalletItem.vue?vue&type=template&id=40d5d00b"
import script from "./RichWalletItem.vue?vue&type=script&lang=js"
export * from "./RichWalletItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports